import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Row, Col, Card } from "react-bootstrap";
import PortfolioPanel from "../dashboard/PortfolioPanel";
import DistributionPanel from "./DistributionPanel";
import CoinPanel from "./CoinPanel";
import ContentContainer from "../common/ContentContainer";
import { getPortfolioDetail } from "../../actions/portfolio-action";
import "./Portfolio.scss";
import { useTranslation } from "react-i18next";
import AssetsList from "./AssetsList";
import FundTab from "./FundTab";

const Portfolio = (props) => {
  const { getPortfolioDetail } = props;
  const {t} = useTranslation()

  const [activeTab, setActiveTab] = useState(0);

  const tabTitles = [t("Funds"), t("Assets")];
  const [timeframe, setTimeframe] = useState("1M");
  const selectedExchange =
    useSelector((state) => state.settings.selectedExchangeId) || 0;
  const forexCoins = useSelector((state) => state.portfolio.forex);
  const currency = useSelector((state) => state.settings.currency);
  const assets = useSelector((state) => state.dashboard.assets);
  const cash = useSelector((state) => state.portfolio.cash);
  const equity = useSelector((state) => state.portfolio.equity);
  const tradeAvailable = useSelector((state) => state.portfolio.tradeAvailable);
  useEffect(() => {
    getPortfolioDetail(selectedExchange);
  }, [selectedExchange]);

  
  const forexCoinstotalBalance =
  forexCoins && forexCoins.total &&
  forexCoins.total.reduce((balance, item) => {
      return balance + item.balance_usd;
    }, 0);
  
  
  const totalCash = forexCoinstotalBalance 
  
  const totalforexCoins =
  forexCoins && forexCoins.total &&
  forexCoins.total
      .filter((item) => item.balance > 0)
      .map((item) => {
        return {
          name: item.coin_name,
          symbol: item.coin_symbol,
          holdings:
          forexCoinstotalBalance === 0 ? 0 : (item.balance_usd * 100) / forexCoinstotalBalance,
          amount: item.balance,
          total: item.balance_usd.toFixed(2),
          image: item.image,
          change: item.change24h,
          price: item.price_usd,
        };
      });
 
  
  const tabHeaders = tabTitles.map((item, index) => {
    return (
      <Col xs={4} sm={2} key={index}>
        <a
          onClick={() => setActiveTab(index)}
          className={index == activeTab ? "tab-active" : "tab-inactive"}
        >
          {item}
        </a>
      </Col>
    );
  });

  const coinTabs = [
    <FundTab  t={t}/>,
    <AssetsList coins={totalforexCoins} isTotal={false} t={t} showImage={false}/>,
  ];

  return (
    <ContentContainer url="portfolio" title={t("portfolio")} showExchange={true}>
      <div className="portfolio">
        <Row noGutters>
          <Col xs={12} xl={12}>
            <div>
            <div className="portfolio-panel">
            <hr />
            <Row className="text-title">
              <Col className="">{t("avl-trade")}</Col>
              <Col className="">{t("cash")}</Col>
              <Col className="">{t("equity")}</Col>
            </Row>
            <Row className="text-value">
              <Col>
                {tradeAvailable} {currency && currency.name}
              </Col>
              <Col>
                {cash} {currency && currency.name} 
              </Col>
              <Col>
                {equity} {currency && currency.name} 
              </Col>
          </Row>
            <hr />
            </div>
            </div>
          </Col>
         
        </Row>
        <Row >
            <Col xs={12} xl={12}>
              {totalforexCoins && totalforexCoins.length > 0 ?
              <DistributionPanel coins={totalforexCoins} t={t}/>:<></>}
            </Col>
        </Row>

        <div className="round-bg bottom-row">
          <Row noGutters>{tabHeaders}</Row>
          {coinTabs[activeTab]}
        </div>
      </div>
    </ContentContainer>
  );
};

export default connect(null, { getPortfolioDetail })(Portfolio);
